import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Loader } from '../../components/Loader';
import * as actions from "../../redux/campaignmonitor";

class CampaignMonitor extends Component {
    componentDidMount() {
        this.props.fetchcampaignmonitorsession(this.props);
    }

    render() {
        return (
            <div>
                <Loader loading={this.props.loading}>
                </Loader>
            </div>
        );
    }
}

const mapStateToProps = ({ campaignmonitor }) => ({
    loading: campaignmonitor.loading,
    error: campaignmonitor.error
});

export default connect(mapStateToProps, actions)(withRouter(CampaignMonitor));


// WEBPACK FOOTER //
// ./src/pages/CampaignMonitor/CampaignMonitor.js